/**
 * The one look a form field has: height, corners, border, and colour.
 *
 * Extracted because three controls that sit side by side in a table row had
 * drifted apart — an `Input` on `bg-surface` at `h-9`, a `<select>`
 * transparent with a different border token, and a chip list's add input
 * dashed, transparent and two pixels shorter. Anything that renders as a
 * field composes this rather than restating it, so the next control cannot
 * quietly become a fourth variant.
 *
 * Compose with `cn`, which merges conflicting utilities, so a caller that
 * genuinely needs a different width or padding can say so and win.
 *
 * `nativeSelect` is deliberately NOT this. It is the denser variant
 * conciliatron's parameter grids use, it predates this, and unifying the two
 * would restyle those screens.
 */
export const fieldClass = [
  "h-9 w-full rounded-md border border-border bg-surface px-3 text-sm text-surface-foreground",
  "placeholder:text-muted-foreground",
  "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
  "disabled:cursor-not-allowed disabled:opacity-50",
].join(" ");
